import Cookies from "js-cookie";

function getCookies<T>(name: string, init: T): T {
  const cookieResponse = JSON.parse(
    Cookies.get(name) || JSON.stringify(init)
  ) as T;

  return cookieResponse;
}
function setCookies<T>(name: string, value: T, expiry: number | Date) {
  const cookieResponse = Cookies.set(name, JSON.stringify(value), {
    expires: expiry,
  });

  return cookieResponse;
}

export { getCookies, setCookies };
